export default {
  init() {
    if ($('form[id*="mc4wp-"]').length) {
      $('form[id*="mc4wp-"]').each(function () {
        var newsletter = $(this);
        var textInputs = $('input[type="email"], input[type="text"]', newsletter);
        var inputFieldFocusClass = 'form-group--focus';

        textInputs.on('focus', function () {
          $(this).closest('p[class*="__form-group"]').addClass(inputFieldFocusClass);
        });

        textInputs.on('blur', function () {
          !$(this).val().length && $(this).closest('p[class*="__form-group"]').removeClass(inputFieldFocusClass);
        });

        newsletter.on('submit', function(e) {
          var checkboxFields = $('[name^="INTERESTS"]', newsletter);
          var responseText = $('p[class*="__list-choice"]', newsletter).data('interest-group-message');
          var responseField = $('.mc4wp-response');

          if( checkboxFields.length ) {
            for (var i=0; i<checkboxFields.length; i++) {
              if (checkboxFields[i].checked) {
                return true;
              }
            }

            responseField.html('<div class="mc4wp-alert mc4wp-error"><p>'+responseText+'</p></div>');

            e.preventDefault();

            return false;
          }

          return true;
        });

        window.mc4wp.forms.on('subscribed', function() {
          window._paq.push(['trackGoal', 1]);
          if (document.documentElement.lang == 'en-US') {
            window._paq.push(['trackGoal', 3]);
          }
        });
      });
    }
  },
};
